export default __webpack_public_path__ + "static/media/calendar.0557ad4c.svg";